import axios from 'axios';

export default {
  getSkill(params = {}) {
    return axios.get('/user/skill', {params});
  },
  getDetail() {
    return axios.get(`/skill/detail`);
  },
  updateSkill(payload = {}) {
    return axios.put(`/skill/update`, payload);
  },
  createSkill(payload = {}) {
    return axios.post(`/skill/create`, payload);
  },
  getDetailSkill(id: string | number) {
    return axios.get(`/user/skill/${id}`);
  },
  delete(id: string | number) {
    return axios.delete(`/user/skill/${id}`);
  },
  getSkills(params = {}) {
    return axios.get('/skill/all', {params});
  },
  getCategory(params = {}) {
    return axios.get('/skill/job-category', {params});
  },
  getSoftSkill(params = {}) {
    return axios.get('/skill/soft-skill', {params});
  },
  getHardSkill(params = {}) {
    return axios.get('/skill/spacial-skill', {params});
  },
};
